import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  triggerBetSettingsViewChangeRequest,
  triggerDefaultViewChangeRequest
} from "../../../core/containers/Keypad/Common/Keypad.actions";
import { handleEvent } from "../../../core/utils/handleEvents";
import { APINames } from "../../../legacy/api/api.names";
import { IState } from "../../redux";
import {
  BetButton as BetButtonComponent,
  IBetButtonProps,
  State
} from "./BetButton";
import { View } from "../../../api/api";

export const BetButton = () => {
  const dispatch = useDispatch();
  const isDisabled = useSelector(
    (state: IState) => state.keypad.betButtonDisabled
  );
  const view = useSelector((state: IState) => state.view);

  const isActive = view === View.BET_SETTINGS;

  let state = State.DEFAULT;

  if (isActive) {
    state = State.ACTIVE;
  } else if (isDisabled) {
    state = State.DISABLED;
  }

  const onClick = () => {
    if (isActive) {
      return dispatch(triggerDefaultViewChangeRequest());
    } else if (isDisabled) {
      return null;
    }

    return dispatch(triggerBetSettingsViewChangeRequest());
  };

  const props: IBetButtonProps = {
    apiName: APINames.BET_BUTTON,
    state,
    onClick: handleEvent(onClick)
  };

  return <BetButtonComponent {...props} />;
};

export { BetButtonWrapperForMobile } from "./BetButton";
